<template>
    <div class="story-4" :class="{'slider-enabled' : sliderClass }">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
            <div v-if="storyIndex === 0" class="faucet-container">
                <div class="left-container">
                    <div class="video-container" @click="checkFaucet('stop')">
                        <div v-if="iPhoneLowerModels('low')">
                            <video id="faucet-video" autoplay playsinline muted>
                                <source src="@/assets/videos/faucet_low.mp4" type="video/mp4"/>
                            </video>
                        </div>
                        <div v-else-if="iPhoneLowerModels('lower')">
                            <video id="faucet-video" autoplay playsinline muted>
                                <source src="@/assets/videos/faucet_lower.mp4" type="video/mp4"/>
                            </video>
                        </div>
                        <div v-else>
                            <video id="faucet-video" muted>
                                <source src="@/assets/videos/faucet.mp4" type="video/mp4"/>
                            </video>
                        </div>
                    </div>
                    <div class="prompt-container">
                        <img class="path" src="@/assets/img/story_4_images/path-4.svg">
                        <div class="cursor">
                            <img ref="promptCursor" src="@/assets/img/story_4_images/cursor.png" class="prompt">
                            <p>Musluğu Kapat</p>
                        </div>
                    </div>
                </div>
                <div class="right-container">
                    <div class="text-container">
                        <p>Sitede geçirdiğiniz {{wastedWaterFormatted}} saniyede bu musluk açık kaldı.</p>
                        <h3><span>{{wastedWaterInLitre}}</span> litre su boşa aktı.</h3>
                        <p>Bulaşıklarınızı her sudan geçirdiğinide de aynı şekilde su israfına sebep oluyoruz.</p>
                        <p>Bulaşıkları sudan geçirmeden <span>Finish</span> ile yıkadığınızda ortalama <span>57</span> litre su tasarrufu
                            kazanabiliriz.</p>
                        <p>Önce musluğu kapatın, sonra neler yapabileceğimize bakalım.</p>
                    </div>
                </div>
                <div class="st-image-container">
                    <img src="@/assets/img/story_4_images/result-product-3.png">
                </div>
            </div>
        </transition>
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
            <div v-if="storyIndex > 0" class="slider-container">
                <Slider :slides="slides"/>
            </div>
        </transition>
        <div v-if="storyIndex > 0" class="story-button-container animated fadeIn" @click="nextSlider">
            <div class="blue-button">
                <img src="@/assets/img/icons/white-drop.svg"/>
                <p>Ne yapabiliriz ?</p>
            </div>
        </div>
    </div>
</template>


<script>
    import ButtonBlueBackground from "../components/ButtonBlueBackground";
    import Slider from "../components/Slider";
    import EventBus from "../main";

    export default {
        name: "Story4",
        data() {
            return {
                storyDone: false,
                storyIndex: 0,
                slides: [
                    {
                        'header': 'Bulaşıklarınızı sudan geçirmeyin',
                        'image': 'story_4_images/11.jpg',
                        'text': 'Bulaşıklarınızı bulaşık makinesine atmadan önce sudan geçirmeyin.Böylece her seferinde 57 litre su tasarruf edebilirsiniz.',
                        'button': 'Ne yapabiliriz?'
                    },
                    {
                        'header': 'Bulaşıklarınızı Elde Değil Makinede Yıkayın',
                        'image': 'story_4_images/03.jpg',
                        'text': '4 kişilik bir ailenin günlük bulaşığını elde yıkarsanız, ortalama 103 litre su harcarsınız. Oysa bulaşık makinesi aynı bulaşığı sadece 9 litre su ile yıkar. Bu da bir yılda ortalama 26 - 40 ton suyu kurtarmanız demektir.',
                        'button': 'Ne yapabiliriz?'
                    },
                    {
                        'header': 'Musluğu Açık Bırakmayın',
                        'image': 'story_4_images/01.jpg',
                        'text': 'Her gün sebzelerimizi elde yıkamak yerine, su dolu bir kapta yıkarsanız, çok daha az su tüketirsiniz. 4 kişilik bir aile bu yöntemle yılda ortalama 18 ton su kurtarabilir.',
                        'button': 'Ne yapabiliriz?'
                    },
                    {
                        'header': 'Diş Fırçalarken, Tıraş Olurken Suyu Kapatın',
                        'image': 'story_4_images/04.jpg',
                        'text': 'Diş fırçalarken ya da tıraş olurken, kullanmadığımız halde açık bıraktığımız su gideri, yılda kişi başı ortalama 12 tondur. 4 kişilik bir ailede bu rakam ortalama 48 tondur.',
                        'button': 'Ne yapabiliriz?'
                    },
                    {
                        'header': 'Daha Kısa Duş Alın',
                        'image': 'story_4_images/02.jpg',
                        'text': '5 dakikalık bir duş sırasında ortalama 60 lt su harcarsınız. 4 kişilik bir ailenin her bir ferdi duş süresini 1 dakika azaltırsa yaklaşık 18 ton su kurtarırsınız.',
                        'button': 'Ne yapabiliriz?'
                    },
                    {
                        'header': 'Gereksiz Yere Sifon Çekmeyin',
                        'image': 'story_4_images/05.jpg',
                        'text': 'Tuvaleti çöp olarak kullanmayın. Dört kişilik bir ailenin her bir ferdi, günde bir kez sifonu amacı dışında çekerse yılda 16 ton su harcamış olur.',
                        'button': 'Ne yapabiliriz?'
                    },
                    {
                        'header': 'Sifona Plastik Bir Şişe Yerleştirin',
                        'image': 'story_4_images/06.jpg',
                        'text': '1,5 litrelik bir pet şişeyi su ile doldurarak sifonunuzun içine yerleştirin. Sadece bu basit önlemle bile yılda 1 ton su kurtarabilirsiniz.',
                        'button': 'Ne yapabiliriz?'
                    },
                    {
                        'header': 'Duş Başlığınızı Değiştirin',
                        'image': 'story_4_images/07.jpg',
                        'text': 'Çıkan suyu daha iyi bir şekilde püskürten yeni ekonomik duş başlıklarından alın. Böylece suyu daha az açarak daha tazyikli bir duş alabilirsiniz.',
                        'button': 'Ne yapabiliriz?'
                    },
                    {
                        'header': 'Muslukları Tamir Ettirin',
                        'image': 'story_4_images/09.jpg',
                        'text': 'Evdeki tüm muslukların su kaçırmadığından emin olun. Gerekirse tamir edin. Her saniye bir damla damlayan musluk yılda 1 ton su harcar.',
                        'button': 'Ne yapabiliriz?'
                    },
                    {
                        'header': 'Su Kaçaklarını Engelleyin',
                        'image': 'story_4_images/10.jpg',
                        'text': 'Evinizdeki ya da apartmanınızdaki su borularını yenileriyle değiştirin ya da tamir ettirin. Eski tip borular tonlarca su harcar.',
                        'button': 'Ne yapabiliriz?'
                    },
                    {
                        'header': 'Çamaşır Makinesini Ekonomik Kullanın',
                        'image': 'story_4_images/08.jpg',
                        'text': 'Bir çamaşır makinesi tek bir çalıştırmada 176 litre su harcar. Makinenizi haftada bir kez bile az kursanız, yılda 9 ton suyu kurtarırsınız.',
                        'button': 'Ne yapabiliriz?'
                    }
                ],
                slidesIndex: 0,
                faucetInterval: null,
                faucetVideo: null,
                sliderClass: false,
                faucetProgress: false
            }
        },
        computed: {
            wastedWaterTime() {
                return new Date().getTime() - this.$store.state.siteEnter;
            },
            wastedWaterFormatted() {
                const hours = Math.floor((this.wastedWaterTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                    minutes = Math.floor((this.wastedWaterTime % (1000 * 60 * 60)) / (1000 * 60)),
                    seconds = Math.floor((this.wastedWaterTime % (1000 * 60)) / 1000);

                return hours > 0 ? hours + ':' + minutes + ':' + seconds : minutes > 0 ? minutes + ':' + seconds : seconds;
            },
            wastedWaterInLitre() {
                return Math.floor((this.wastedWaterTime / 1000) / 4);
            }
        },
        watch: {
            storyDone(value) {
                value ? EventBus.$emit('story-done', { story : 4, value : true}) : EventBus.$emit('story-done', { story : 4, value : false });
            }
        },
        methods: {
            nextSlider() {
                if (this.slidesIndex === this.slides.length - 1) {
                    this.$router.push({name: 'Story5'});
                } else {
                    this.slidesIndex++;
                    EventBus.$emit('next-slide');
                }
            },
            playFaucet() {
                this.faucetVideo = document.getElementById('faucet-video');
                this.faucetVideo.currentTime = 4;
                this.faucetVideo.play();
                this.checkFaucet('start');
            },
            checkFaucet(type) {
                switch (type) {
                    case 'start':
                        this.faucetInterval = setInterval(() => {
                            this.faucetVideo.currentTime >= 12 ? this.faucetVideo.currentTime = 4 : false;
                        }, 1000);
                        break;
                    case 'stop':
                        if (!this.faucetProgress) {
                            this.$refs.promptCursor.classList.remove('prompt');
                            this.faucetProgress = true;
                            this.faucetVideo.currentTime = 13.4;
                            clearInterval(this.faucetInterval);
                            setTimeout(() => {
                                document.getElementsByTagName('body')[0].classList.remove('faucet');
                                this.storyIndex++;
                                this.sliderClass = true;
                            }, 5000);
                        } else {
                            return false;
                        }
                        break;
                }
            },
            iPhoneLowerModels(screenVersion){
                var ua = navigator.userAgent.toLowerCase();
                if ((ua.indexOf("safari/") > -1 && ua.indexOf("chrome") < 0)) { // safari check
                    var h = window.screen.height;
                    var w = window.screen.width;
                    var dpr = window.devicePixelRatio;
                    switch (screenVersion) {
                        case 'low':
                            if ((h / w == 736 / 414) && (dpr == 3) // iPhone 6 Plus, 6s Plus, 7 Plus or 8 Plus
                                || (h / w == 667 / 375) && (dpr == 3) // iPhone 6 Plus, 6s Plus, 7 Plus or 8 Plus (display zoom)
                                || (h / w == 667 / 375) && (dpr == 2)) { // iPhone 6, 6s, 7 or 8
                                    return true;
                                }
                            break;
                        case 'lower':
                            if (((h / w == 1.775) && (dpr == 2)) // iPhone 5, 5C, 5S, SE or 6, 6s, 7 and 8 (display zoom)
                                || (h / w == 1.5)  && (dpr == 2) // iPhone 4 or 4s
                                || (h / w == 1.5)  && (dpr == 1)) { // iPhone 1, 3G or 3GS
                                    return true;
                                }
                            break;
                    }
                }
                return false;
            }
        },
        mounted() {
            this.storyIndex = 0;
            this.slidesIndex = 0;
            EventBus.$emit('story-start');
            this.playFaucet();
            document.getElementsByTagName('body')[0].classList.add('faucet');

            EventBus.$emit('menu-status', false);
            this.$store.commit('navigationStatus','story');
            this.$store.commit('changeStory',4);
            EventBus.$on('restart-story', () => {
                this.storyDone = false;
                this.startStory();
            })
        },
        beforeDestroy() {
            document.getElementsByTagName('body')[0].classList.remove('faucet');
        },
        components: {Slider, ButtonBlueBackground},
    }
</script>

<style lang="scss">
    body.faucet {
        cursor: pointer;
    }

    .story-4 {
        width: 100%;
        margin: 0 auto auto auto;
        height: 700px !important;
        overflow: visible;
        position: relative;

        &.slider-enabled {
            max-width: 100vw !important;
        }

        .faucet-container {
            display: flex;
            width: 100%;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            margin-bottom: 15vh;

            .left-container {
                position: relative;

                .video-container {
                    width: 400px;
                    height: 400px;
                    overflow: hidden;
                    border: none;
                    border-radius: 100%;
                    position: relative;
                    margin-right: 50px;

                    video {
                        position: absolute;
                        right: 0;
                        min-width: 100%;
                        min-height: 100%;
                        height: 100%;
                        width: auto;
                        top: initial;
                        left: initial;
                        z-index: initial;
                        transform: initial;
                    }
                }

                .prompt-container {
                    position: absolute;
                    right: 0;
                    display: flex;
                    align-items: baseline;

                    img.path {
                        transform: rotateZ(90deg) rotateX(180deg);
                        margin-right: 15px;
                    }

                    .cursor {
                        display: flex;
                        flex-direction: column;

                        img {
                            width: 30px;
                            height: 35px;
                            object-fit: contain;
                            margin: auto;
                            position: relative;
                            left: 0;
                            top: 0;

                            &.prompt {
                                animation: cursorAnimation 10s ease-in-out infinite;
                                animation-delay: 3s;
                            }
                        }
                    }
                }
            }

            .right-container {
                max-width: 368px;

                .text-container {
                    margin: auto 5px;

                    h3 {
                        display: flex;
                        align-items: center;
                        font-size: 23px;
                        font-weight: bold;

                        span {
                            font-size: 32px;
                            margin-right: 5px;
                        }
                    }

                    p {
                        font-size: 15px;
                        span {
                            font-size: 24px;
                            font-weight: bolder;
                        }
                    }
                }
            }

            .st-image-container {
                img {
                    width: 208px;
                    height: 208px;
                    object-fit: contain;
                }
            }
        }

        .story-button-container {
            width: auto;
            cursor: pointer;
            position: absolute;
            right: 60px;
            bottom: 30px;
            z-index: 20;
        }

        .slider-container {
            position: absolute;
            width: 100%;
        }


        @media only screen and (max-device-width: 768px) {
            height: 80% !important;
            flex-wrap: nowrap;
            min-height: initial;
            position: relative;
            margin: auto 0;
            top: initial;
            max-height: 80vh;

            .faucet-container {
                flex-direction: column;

                .left-container .prompt-container .cursor p{
                    display: none;
                }

                .right-container {
                    width: 90%;
                    max-width: initial;
                    margin-top: 120px;
                    .text-container {
                        p {
                            font-size: 36px;
                        }
                        h3 {
                            font-size: 36px;
                            span {
                                font-size: 52px;
                                margin-right: 15px;
                            }
                        }
                    }
                }
            }

            .slider-container {
                #slider-component {
                    .sc-header {
                        min-height: 190px;
                        width: 90%;
                        margin: 0 auto;
                    }
                    .sc-text {
                        font-size: 36px;
                        min-height: 190px;
                    }
                }
            }


            .story-button-container {
                right: initial !important;
                left: 50%;
                transform: translateX(-50%);
                bottom: 140px;

                div.blue-button {
                    width: 670px;
                    min-height: 100px;
                    img {
                        height: 56px;
                        width: auto;
                    }
                    p {
                        font-size: 30px;
                    }
                }
            }
        }

        @media only screen and (max-width: 768px) {
            height: 100% !important;
            padding-top: 45px;

            &.slider-enabled {
                position: relative;
                min-height: 900px;
                padding-bottom: 25px;
                .story-button-container {
                    right: initial;
                    left: 50%;
                    transform: translateX(-50%);
                    bottom: 75px;
                }
            }
            .faucet-container {
                flex-direction: column;
                .left-container {
                    padding-bottom: 115px;
                }
            }

            .story-button-container {
                transform: translateX(-50%);
            }
        }
    }


    @keyframes cursorAnimation {
        0% {
            width: 30px;
            height: 35px;
            top: 0;
            left: 0;
        }

        20% {
            width: 30px;
            height: 35px;
            left: -210px;
            top: -260px;
        }

        25% {
            width: 23px;
            height: 29px;
            left: -210px;
            top: -260px;
        }

        27% {
            width: 30px;
            height: 35px;
        }

        50% {
            width: 30px;
            height: 35px;
            left: -210px;
            top: -260px;
        }

        60%, 100% {
            top: 0;
            left: 0;
        }
    }
</style>









































